import React from 'react';
import { Modal, Spin } from 'antd';
import { GalleryImage, VideoPlayer, UploadCsvIcon } from '../assets/icon';
import Loader from '../components/Loder/loader';

const PreviewModal = ({ open, onCancel, file }) => {
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        if (open) {
            setLoading(true);
        }
    }, [open, file]);

    if (!file) return null;
    const { fileUrl, type, name, size } = file;

    const renderContent = () => {
        return (
            <div className="preview-content-area">
                {loading && (
                    <div className="preview-loader-container">
                        <Loader />
                    </div>
                )}
                <div className={loading ? 'preview-hidden' : 'preview-visible'}>
                    {type === 'image' && (
                        <div className="preview-image-container">
                            <img
                                src={fileUrl}
                                alt={name}
                                className="preview-image"
                                onLoad={() => setLoading(false)}
                            />
                        </div>
                    )}
                    {type === 'video' && (
                        <div className="preview-video-container">
                            <video
                                controls
                                className="preview-video"
                                autoPlay
                                onCanPlay={() => setLoading(false)}
                            >
                                <source src={fileUrl} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    )}
                    {type === 'pdf' && (
                        <div className="preview-pdf-container">
                            <iframe
                                src={`${fileUrl}#toolbar=0`}
                                title={name}
                                className="preview-pdf"
                                width="100%"
                                height="600px"
                                onLoad={() => setLoading(false)}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const getFileIcon = () => {
        if (type === 'image') return <GalleryImage color="#162C4E" />;
        if (type === 'video') return <VideoPlayer color="#162C4E" />;
        if (type === 'pdf') return <UploadCsvIcon color="#162C4E" />;
        return null;
    };

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            footer={null}
            closeIcon={null}
            width={700}
            className="preview-modal-custom"
            centered
            destroyOnClose
        >
            <div className="preview-modal-header">
                <span className="preview-modal-title">Preview</span>
            </div>
            <div className="preview-modal-body">
                {renderContent()}

                <div className="preview-footer-section">
                    <div className="preview-file-meta">
                        <div className="preview-icon-wrapper">
                            {getFileIcon()}
                        </div>
                        <div className="preview-text-wrapper">
                            <div className="preview-filename fs-16 fw-bold">{name}</div>
                            <div className="preview-filesize fs-14">{size}</div>
                        </div>
                    </div>
                    <hr className="m-0  manage-campaign-divider" />
                    <button className="preview-action-close-btn fs-16" onClick={onCancel}>
                        Close
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default PreviewModal;
